// i18n — L10N object, consistent with player.html and scene pages
// Key naming: English is the key, zh is the translation

const L10N = {
  zh: {
    // Site Description
    siteDescription: 'FreeMusic.Top 提供高品质免费音乐和智能播放器，适合听众和创作者使用。每首歌曲均可免费在线收听与下载，个人和商业用途均无需署名。',

    // Nav
    explore: '探索',
    trackLibrary: '曲库',
    pricing: '定价',
    listenFree: '自由畅听',
    login: '登录',
    logout: '退出',
    user: '用户',
    startListening: '免费畅听',
    immersionPlay: '沉浸式畅听',
    scenePlaylist: '氛围歌单',
    scenePlaylistNav: 'Ambient Tracks',
    userPlaylist: '用户自制歌单',
    randomPlay: '随机畅听',

    // Hero tag
    heroTag: '品类管够 · 总有一款 · 分文不取 ·',
    heroTitle: '总有',
    heroTitleGradient: '恰好那一首',
    heroDesc: '懂你的每一种情绪。无论是专注工作、深夜放松、还是给视频找一段配乐——这里总有一首对的。即开即听，喜欢就下载，全场景自由使用。',

    // Business cards
    listenCardTitle: '免费畅听',
    listenCardDesc: '海量场景音乐，在线即听，全部免费',
    downloadCardTitle: '下载商用',
    downloadCardDesc: '单首购买或订阅后无限下载',

    // Stats
    sceneCount: '个场景',
    royaltyFree: '版权无忧',
    freeStart: '$0 起听',

    // Search
    searchPlaceholder: '搜索场景、情绪、用途...',
    searchResultsFound: '找到',
    searchResults: '个场景',
    searchAbout: '关于',
    searchResultsFor: '的结果',

    // No results
    noResultsTitle: '没有找到匹配的场景',
    noResultsDesc: '试试其他关键词或分类',

    // Use cases section
    useCasesTitle: '适用场景',
    useCasesDesc: '覆盖内容创作的每一个环节',
    useCases: {
      '视频剪辑': '视频剪辑',
      '游戏BGM': '游戏BGM',
      '直播背景': '直播背景',
      '播客': '播客',
      '冥想引导': '冥想引导',
      '纪录片': '纪录片',
      '预告片': '预告片',
      '短视频': '短视频',
    },

    // Scene card
    sceneBtn: '场景',
    perUse: '/ 次',

    // Pricing
    pricingTitle: '简单定价',
    pricingDesc: '免费听音乐，需要时再付费下载',
    freeTier: '免费版',
    foreverFree: '永远免费',
    freeFeature1: '全部场景免费在线听（含广告）',
    freeFeature2: '每月 20 次免费下载',
    freeFeature3: '商业授权，版权无忧',
    freeCTA: '免费开始听',
    creatorTier: '创作者版',
    perMonth: '/月',
    monthlyDownloads: '月度下载',
    resetsOn: '每月',
    nextBilling: '下次续费',
    bonusCredits: '额外 Credits',
    neverExpire: '永不过期',
    usageOverview: '使用概览',
    monthlyLimit: '月限额',
    upgradeToCreator: '升级到 Creator 🌟',
    totalPurchased: '累计购买',
    purchaseHistory: '购买记录',
    noCredits: '暂未购买 Credits',
    subscribe: '订阅',
    perYear: '/年',
    comingSoon: '即将推出',
    or: '或',
    savePct: '（省 30%）',
    mostPopular: '最受欢迎',
    creatorFeature1: '无广告畅听，优先试用新曲目',
    creatorFeature2: '无限下载（MP3 + WAV）',
    creatorFeature3: '所有场景包免费',
    creatorFeature4: '商业授权，版权无忧',
    subscribeNow: '立即订阅',
    stillHesitate: '还在犹豫？可以先试用',
    stillHesitateLink: '免费畅听',
    stillHesitateSuffix: '，满意了再订阅',

    // Footer
    scenes: '场景',
    links: '链接',
    player: '播放器',
    focusMode: '专注模式',
    about: '关于',
    copyright: '© 2026 FreeMusic.Top. All rights reserved.',
    friendLinks: '友情链接',
    scanToListen: '扫码听音乐',
    websiteQR: '本站入口',
    miniProgramQR: '微信小程序',

    // Categories (from scenes.js — also provided here for easy access)
    categories: {'all': '全部', 'relaxing': '放松', 'tense': '紧张', 'horror': '恐怖', 'poetry': '古风', 'female-lavish': '慵懒', 'male-deep': '叙事'},

    tags: '标签',
    description: '场景描述',
    mood: '情绪',
    useCasesShort: '适用场景',
    licenseInfo: '版权无忧',
    licenseDesc: '本曲目包含免费商用授权，详情请查看定价页',
    trackType: '类型',
    duration: '时长',
    category: '分类',
    trackId: '曲目ID',
    play: '播放',
    addToPlaylist: '加入播放列表',
    details: '详细信息',

    // TrackSelector
    fetchFailed: '获取曲目失败',
    loading: '加载中...',
    noTracks: '暂无曲目',
    track: '曲目',
    vocal: '演唱',
    instrumental: '器乐',
    tracks: '首',
    clickPlay: '点击播放',
    multiSelect: '多选',
    multiSelectOn: '取消多选',
    page: '页',

    // Player
    selectLicense: '选择许可证',
    freePersonal: '个人免费',
    previewOnly: '仅预览，不可商用',
    recommended: '推荐',
    payPerUse: '按次付费',
    creditsDesc: '$1 得 50 Credits，可下载 50 首曲目，永不过期',
    monthlySub: '月度订阅',
    perMonthCommercial: '/月，无限商用',

    // PlayerBar
    nowPlaying: '正在播放',
    previous: '上一首',
    next: '下一首',
    openPlayer: '打开播放器',
    openImmersive: '沉浸模式',
    share: '分享',
    shareCopied: '链接已复制',
    volumeLabel: '音量',
    playlistSource: '用户歌单',
    likedSource: '喜欢列表',
    favoritesSource: '收藏列表',
    exploreSource: '探索列表',
    tempSource: '在播列表',
    shuffleMode: '随机播放',
    dislike: '不喜欢',
    fullFeature: '全功能',

    // Like & Favorite
    like: '喜欢',
    unlike: '取消喜欢',
    favorite: '收藏',
    unfavorite: '取消收藏',

    // Playlist
    playlist: '播放列表',
    playlistEmpty: '播放列表为空',
    clearPlaylist: '清空列表',
    removeFromPlaylist: '移除',
    showPlaylist: '展开列表',
    collapsePlaylist: '收起列表',
    shuffle: '随机播放',
    loopMode: '循环模式',
    loopOne: '单曲循环',
    loopAll: '列表循环',
    loopOff: '顺序播放',

    // Download
    download: '下载',
    quotaUsed: '已用',
    quotaRemaining: '剩余',
    quotaExhausted: '本月免费下载次数已用尽',
    quotaExhaustedDesc: '订阅后无限下载，或按次购买',
    downloadInProgress: '下载中...',
    downloadLimitExceeded: '下载次数已用完，升级后可无限下载',
    downloadStarted: '开始下载',
    downloadSuccess: '下载成功',
    downloadFailed: '下载失败',
    quotaUnlimited: '无限',
    needLoginForDownload: '请先登录后下载',
    guestPromptTitle: '登录解锁免费下载',
    guestPromptDesc: '每月 20 首免费额度，升级 Creator 可享无限下载',
    guestPromptCTA: '登录 / 注册',
    guestPromptListen: '先听听看',
    batchDownload: '批量下载',
    selectAll: '全选',
    deselectAll: '取消全选',
    selectedForDownload: '已选',

    // Pricing Modal
    upgradeTitle: '升级以继续下载',
    upgradeDesc: '免费用户每月可下载 20 次。升级后无限下载。',
    buyCredits: '购买下载次数',
    credits: '次下载',
    orSubscribe: '或订阅',
    unlimitedDownloads: '无限下载',
    subscribeForUnlimited: '订阅后无限下载所有曲目',
    alreadySubscribed: '您已订阅 Creator 计划',
    manageSubscription: '管理订阅',
    redirectingToStripe: '跳转中...',
    bonusDownloads: '额外下载次数',
    monthly: '月度',
    yearly: '年度',
    save2Months: '省下2个月，相当于免费2个月',
    bestValue: '最划算',
    planActive: '已订阅',

    // User Library
    myLibrary: '我的音乐库',
    myLikes: '我的喜欢',
    myFavorites: '我的收藏',
    noLikedTracks: '还没有喜欢的曲目',
    noFavoritedTracks: '还没有收藏的曲目',

    // Playlist Management
    playlistManage: '我的歌单',
    profile: '个人主页',
    currentPlan: '当前方案',
    freePlan: '免费用户',
    downloadSummary: '下载概览',
    downloaded: '已下载',
    pricingOptions: '价格方案',
    adminPanel: '管理面板',
    createPlaylist: '创建歌单',
    playlistName: '歌单名称',
    playlistDesc: '歌单描述',
    playlistCreated: '歌单创建成功',
    playlistDeleted: '歌单已删除',
    deleteConfirm: '确认删除',
    deletePlaylistConfirm: '确定删除这个歌单吗？',
    playlistSectionDesc: '管理你的歌单收藏',
    tracksInPlaylist: '首曲目',
    loginPrompt: '登录后可创建和管理歌单',
    emptyPlaylist: '这个歌单还没有曲目',
    hotPlaylists: '热门歌单',
    hotPlaylistsDesc: '社区推荐的精选歌单',
    viewAllPlaylists: '查看全部歌单',
    allPlaylists: '全部歌单',
    myPlaylists: '我的歌单',
    // eslint-disable-next-line no-dupe-keys
    previous: '上一页',
    // eslint-disable-next-line no-dupe-keys
    next: '下一页',
    sharePlaylist: '分享歌单',
    sharePlaylistCopied: '歌单链接已复制',
    // eslint-disable-next-line no-dupe-keys
    addToPlaylist: '添加到歌单',
    selectPlaylist: '选择歌单',
    createFromLibrary: '从已选创建歌单',
    selectTracks: '选择曲目',
    selectedCount: '已选',
    cancel: '取消',
    confirm: '确定',
    playlistDetail: '歌单详情',
    addTracks: '添加曲目',
    playAll: '播放全部',
    addTracksTitle: '选择来源',
    addTracksSource: '选择来源添加曲目',
    fromLiked: '我的喜欢',
    fromFavorites: '我的收藏',
    fromPlayingList: '当前播放列表',
    fromPlaylist: '从歌单选择',
    selectSource: '选择来源',
    addSelected: '添加选中曲目',
    addSelected_plural: '添加选中曲目（{count}首）',
    selectPlaylistFirst: '请先选择一个歌单',
    loadingTracks: '加载中...',
    coverUpdated: '封面已更新',
    addCover: '添加封面',
    changeCover: '更换封面',
    uploadFromDevice: '从设备上传',

    // Login Method Selection
    signIn: '登录',
    emailLogin: '邮箱验证码登录',
    emailLoginHint: '通过邮箱接收6位验证码',
    googleLogin: 'Google 账号登录',
    googleLoginHint: '使用 Google 账号一键登录',

    // Email Login
    emailLoginTitle: '邮箱登录',
    emailLoginDesc: '我们将向您的邮箱发送一个6位验证码',
    emailPlaceholder: 'your@email.com',
    sendCode: '发送验证码',
    sending: '发送中...',
    verifyCodeTitle: '输入验证码',
    verifyCodeDesc: '验证码已发送至 {email}',
    codePlaceholder: '6位验证码',
    verify: '验证并登录',
    verifying: '验证中...',
    useDifferentEmail: '使用其他邮箱',
  },

  en: {
    // Site Description
    siteDescription: 'FreeMusic.Top offers top-quality free music with a smart player and personalized recommendations. Perfect for both listeners exploring new sounds and creators needing royalty-free tracks. Every song is free to stream and download for personal and commercial use. No attribution required.',

    // Nav
    explore: 'Explore',
    trackLibrary: 'Tracks',
    pricing: 'Pricing',
    listenFree: 'FreeMusic Player',
    login: 'Login',
    logout: 'Logout',
    user: 'User',
    startListening: 'Start Listening',
    immersionPlay: 'Immersive Player',
    scenePlaylist: 'Discover Tracks',
    scenePlaylistNav: 'Ambient Tracks',
    userPlaylist: 'User Playlists',
    randomPlay: 'Random Play',

    // Hero tag
    heroTag: 'Pick a Vibe · Find Your Match · Pay Nothing',
    heroTitle: "There's Always",
    heroTitleGradient: 'The Right Track',
    heroDesc: `Music that gets you. Whether you're deep in focus, winding down at night, or searching for that missing piece for your video — there's always the right one. Play instantly, download freely, use everywhere.`,

    // Business cards
    listenCardTitle: '🎧 Stream Free',
    listenCardDesc: 'All scenes, online, instant play — totally free',
    downloadCardTitle: '⬇️ Download',
    downloadCardDesc: 'Single purchase or subscribe for unlimited downloads',

    // Stats
    sceneCount: ' scenes',
    royaltyFree: 'Royalty-Free',
    freeStart: 'From $0',

    // Search
    searchPlaceholder: 'Search scenes, moods, use cases...',
    searchResultsFound: 'Found',
    searchResults: ' scenes',
    searchAbout: 'about',
    searchResultsFor: '',

    // No results
    noResultsTitle: 'No scenes found',
    noResultsDesc: 'Try different keywords or categories',

    // Use cases section
    useCasesTitle: 'Use Cases',
    useCasesDesc: 'Every creative scenario covered',
    useCases: {
      '视频剪辑': 'Video Editing',
      '游戏BGM': 'Game BGM',
      '直播背景': 'Live Stream',
      '播客': 'Podcast',
      '冥想引导': 'Meditation',
      '纪录片': 'Documentary',
      '预告片': 'Trailer',
      '短视频': 'Short Video',
    },

    // Scene card
    sceneBtn: 'Scene',
    perUse: ' / use',

    // Pricing
    pricingTitle: 'Simple Pricing',
    pricingDesc: 'Listen free, pay only when you need to download',
    freeTier: 'Free',
    foreverFree: 'Forever free',
    freeFeature1: 'All scenes — stream online (with ads)',
    freeFeature2: '20 free downloads per month',
    freeFeature3: 'Commercial license included',
    freeCTA: 'Start Listening',
    creatorTier: 'Creator',
    perMonth: '/mo',
    monthlyDownloads: 'Monthly downloads',
    resetsOn: 'Resets on the',
    nextBilling: 'Next billing',
    bonusCredits: 'Bonus Credits',
    neverExpire: 'Never expire',
    usageOverview: 'Usage',
    monthlyLimit: 'Monthly limit',
    upgradeToCreator: 'Upgrade to Creator 🌟',
    totalPurchased: 'Total Purchased',
    purchaseHistory: 'Purchase History',
    noCredits: 'No credits purchased yet',
    subscribe: 'Subscribe',
    perYear: '/year',
    comingSoon: 'Coming Soon',
    or: 'or',
    savePct: '(save 30%)',
    mostPopular: 'Most Popular',
    creatorFeature1: 'Ad-free listening, early access to new tracks',
    creatorFeature2: 'Unlimited downloads (MP3 + WAV)',
    creatorFeature3: 'All scene packs included',
    creatorFeature4: 'Commercial license included',
    subscribeNow: 'Subscribe',
    stillHesitate: 'Not sure? Try',
    stillHesitateLink: 'Stream Free',
    stillHesitateSuffix: ' first, subscribe anytime',

    // Footer
    scenes: 'Scenes',
    links: 'Links',
    player: 'Player',
    focusMode: 'Focus Mode',
    about: 'About',
    copyright: '© 2026 FreeMusic.Top. All rights reserved.',
    friendLinks: 'Friend Links',
    scanToListen: 'Scan to Listen',
    websiteQR: 'Website',
    miniProgramQR: 'WeChat Mini',

    // Categories
    categories: {'all': 'All', 'relaxing': 'Relaxing', 'tense': 'Tense', 'horror': 'Horror', 'poetry': 'Poetry', 'female-lavish': 'Lush', 'male-deep': 'Narrative'},

    tags: 'Tags',
    description: 'Description',
    mood: 'Mood',
    useCasesShort: 'Use Cases',
    licenseInfo: 'License Included',
    licenseDesc: 'This track includes a free commercial license. See pricing page for details.',
    trackType: 'Type',
    duration: 'Duration',
    category: 'Category',
    trackId: 'Track ID',
    play: 'Play',
    addToPlaylist: 'Add to Playlist',
    details: 'Details',

    // TrackSelector
    fetchFailed: 'Failed to load tracks',
    loading: 'Loading...',
    noTracks: 'No tracks yet',
    track: 'Track',
    vocal: 'Vocal',
    instrumental: 'Instrumental',
    tracks: ' tracks',
    clickPlay: 'Click to play',
    multiSelect: 'Multi-select',
    multiSelectOn: 'Done',
    page: 'Page',

    // Player
    selectLicense: 'Select License',
    freePersonal: 'Free (Personal)',
    previewOnly: 'Preview only, no commercial use',
    recommended: 'Recommended',
    payPerUse: 'Pay per use',
    creditsDesc: '$1 = 50 credits → 50 tracks, never expire',
    monthlySub: 'Monthly',
    perMonthCommercial: '/mo, unlimited commercial',

    // PlayerBar
    nowPlaying: 'Now Playing',
    previous: 'Previous',
    next: 'Next',
    openPlayer: 'Open Player',
    openImmersive: 'Immersive',
    share: 'Share',
    shareCopied: 'Link copied',
    volumeLabel: 'Volume',
    playlistSource: 'Custom List',
    likedSource: 'Liked',
    favoritesSource: 'Favorites',
    exploreSource: 'Explore',
    tempSource: 'PlayingList',
    shuffleMode: 'Shuffle',
    dislike: 'Not interested',
    fullFeature: 'Full Features',

    // Like & Favorite
    like: 'Like',
    unlike: 'Unlike',
    favorite: 'Favorite',
    unfavorite: 'Unfavorite',

    // Playlist
    playlist: 'Playlist',
    playlistEmpty: 'Playlist is empty',
    clearPlaylist: 'Clear Playlist',
    removeFromPlaylist: 'Remove',
    showPlaylist: 'Show Playlist',
    collapsePlaylist: 'Collapse Playlist',
    shuffle: 'Shuffle',
    loopMode: 'Loop Mode',
    loopOne: 'Repeat One',
    loopAll: 'Repeat All',
    loopOff: 'Sequential',

    // Download
    download: 'Download',
    quotaUsed: 'Used',
    quotaRemaining: 'Remaining',
    quotaExhausted: 'Free downloads exhausted',
    quotaExhaustedDesc: 'Subscribe for unlimited downloads, or buy credits',
    downloadInProgress: 'Downloading...',
    downloadLimitExceeded: 'Download limit reached. Upgrade for unlimited downloads.',
    downloadStarted: 'Download started',
    downloadSuccess: 'Downloaded',
    downloadFailed: 'Download failed',
    quotaUnlimited: 'Unlimited',
    needLoginForDownload: 'Please log in to download',
    guestPromptTitle: 'Sign In to Download for Free',
    guestPromptDesc: '20 free downloads per month. Upgrade to Creator for unlimited.',
    guestPromptCTA: 'Sign In / Sign Up',
    guestPromptListen: 'Listen First',
    batchDownload: 'Batch Download',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    selectedForDownload: 'Selected',

    // Pricing Modal
    upgradeTitle: 'Upgrade to Keep Downloading',
    upgradeDesc: 'Free users get 20 downloads per month. Upgrade for unlimited.',
    buyCredits: 'Buy Download Credits',
    credits: ' credits',
    orSubscribe: 'or Subscribe',
    unlimitedDownloads: 'Unlimited',
    subscribeForUnlimited: 'Subscribe for unlimited downloads',
    alreadySubscribed: 'You\'re on the Creator plan',
    manageSubscription: 'Manage Subscription',
    redirectingToStripe: 'Redirecting...',
    bonusDownloads: 'bonus downloads',
    monthly: 'Monthly',
    yearly: 'Yearly',
    save2Months: 'Save 2 months — essentially 2 months free',
    bestValue: 'Best Value',
    planActive: 'Active',

    // User Library
    myLibrary: 'My Library',
    myLikes: 'My Likes',
    myFavorites: 'My Favorites',
    noLikedTracks: 'No liked tracks yet',
    noFavoritedTracks: 'No favorited tracks yet',

    // Playlist Management
    playlistManage: 'My Playlists',
    profile: 'Profile',
    currentPlan: 'Current Plan',
    freePlan: 'Free',
    downloadSummary: 'Download Summary',
    downloaded: 'Downloaded',
    pricingOptions: 'Pricing',
    adminPanel: 'Admin Panel',
    createPlaylist: 'Create Playlist',
    playlistName: 'Playlist Name',
    playlistDesc: 'Description',
    playlistCreated: 'Playlist created',
    playlistDeleted: 'Playlist deleted',
    deleteConfirm: 'Delete',
    deletePlaylistConfirm: 'Delete this playlist?',
    playlistSectionDesc: 'Manage your playlist collection',
    tracksInPlaylist: ' tracks',
    loginPrompt: 'Login to create and manage playlists',
    emptyPlaylist: 'This playlist is empty',
    hotPlaylists: 'Hot Playlists',
    hotPlaylistsDesc: 'Community recommended playlists',
    viewAllPlaylists: 'View All Playlists',
    allPlaylists: 'All Playlists',
    myPlaylists: 'My Playlists',
    // eslint-disable-next-line no-dupe-keys
    previous: 'Previous',
    // eslint-disable-next-line no-dupe-keys
    next: 'Next',
    sharePlaylist: 'Share Playlist',
    sharePlaylistCopied: 'Playlist link copied',
    // eslint-disable-next-line no-dupe-keys
    addToPlaylist: 'Add to Playlist',
    selectPlaylist: 'Select Playlist',
    createFromLibrary: 'Create playlist from selection',
    selectTracks: 'Select Tracks',
    selectedCount: 'Selected',
    cancel: 'Cancel',
    confirm: 'OK',
    playlistDetail: 'Playlist Details',
    addTracks: 'Add Tracks',
    playAll: 'Play All',
    addTracksTitle: 'Select Source',
    addTracksSource: 'Choose a source to add tracks from',
    fromLiked: 'Liked Tracks',
    fromFavorites: 'Favorited Tracks',
    fromPlayingList: 'Current Playing List',
    fromPlaylist: 'From Another Playlist',
    selectSource: 'Select Source',
    addSelected: 'Add Selected Tracks',
    addSelected_plural: 'Add Selected Tracks ({count})',
    selectPlaylistFirst: 'Please select a playlist first',
    loadingTracks: 'Loading...',
    coverUpdated: 'Cover updated',
    addCover: 'Add Cover',
    changeCover: 'Change Cover',
    uploadFromDevice: 'Upload from device',

    // Login Method Selection
    signIn: 'Sign in',
    emailLogin: 'Sign in with Email',
    emailLoginHint: 'Receive a 6-digit code via email',
    googleLogin: 'Sign in with Google',
    googleLoginHint: 'Quick sign in with your Google account',

    // Email Login
    emailLoginTitle: 'Sign in with Email',
    emailLoginDesc: "We'll send a 6-digit code to your email address",
    emailPlaceholder: 'your@email.com',
    sendCode: 'Send verification code',
    sending: 'Sending...',
    verifyCodeTitle: 'Enter verification code',
    verifyCodeDesc: 'Code sent to {email}',
    codePlaceholder: '6-digit code',
    verify: 'Verify & sign in',
    verifying: 'Verifying...',
    useDifferentEmail: 'Use a different email',
  },
};

// Language detection: localStorage → navigator
export function detectLang() {
  const stored = localStorage.getItem('fm_lang');
  if (stored === 'zh' || stored === 'en') return stored;
  const nav = navigator.language || navigator.browserLanguage || '';
  if (nav.startsWith('zh')) return 'zh';
  return 'en';
}

export function t(lang, key) {
  const val = L10N[lang];
  if (!val) return key;
  // Handle nested keys like 'useCases.视频剪辑'
  if (key.includes('.')) {
    const parts = key.split('.');
    let obj = val;
    for (const p of parts) {
      obj = obj?.[p];
      if (obj === undefined) return key;
    }
    return obj;
  }
  return val[key] ?? key;
}

export function catName(lang, catId, fallback) {
  return L10N[lang]?.categories?.[catId] ?? fallback ?? catId;
}

export default L10N;
